/**
 * PKCE (Proof Key for Code Exchange) using Web Crypto API.
 * No npm crypto package - browser only.
 * @returns {Promise<{ codeVerifier: string, codeChallenge: string }>}
 */
export const generatePKCE = () => {
  const codeVerifier = generateCodeVerifier();
  return generateCodeChallenge(codeVerifier).then((codeChallenge) => ({
    codeVerifier,
    codeChallenge,
  }));
};

const generateCodeVerifier = () => {
  const array = new Uint8Array(32);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(array);
  }
  return base64UrlEncode(array);
};

const base64UrlEncode = (buffer) => {
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const generateCodeChallenge = (verifier) => {
  if (typeof crypto === 'undefined' || !crypto.subtle) {
    return Promise.reject(new Error('Web Crypto API not available'));
  }
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  return crypto.subtle.digest('SHA-256', data).then((hash) => base64UrlEncode(hash));
};

/**
 * Generate random state string for CSRF protection.
 * @returns {string}
 */
export const generateState = () => {
  const array = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(array);
  }
  return base64UrlEncode(array);
};
